<script>
    import MobilePopup from './mobilePop.svelte';
    export let text = 'Join Actor Governace Council';
    export let text2 = '(Actor Seat)';
    export let height='10.047vw';
    export let width = '43.458vw';
    export let bgcolor = 'black';
    export let txtcolor = 'white';
    export let txtsize = '2.336vw';
    export let txtsize2 = '1.869vw ';
    export let txtweight2 = '900';
    export let lineheight = '6.336vw';
    export let lineheighttxt2 = '1.037vw';
    export let border = 'none';
    export let margin = 'auto';
    export let state = 'temp';
    let edit = false;
</script>

<div class="main"
    role="presentation"
    on:click={() => {
        edit = true;
    }}>
    <div class="btn" style="height:{height}; width:{width}; background-color:{bgcolor}; border:{border};margin:{margin}">
     <div class="txt" style="color:{txtcolor}; line-height:{lineheight}; font-size:{txtsize};">{text}</div>
     <div class="txt2" style="color:{txtcolor}; font-size:{txtsize2}; font-weight:{txtweight2}; line-height: {lineheighttxt2};">{text2}</div>
    </div>
</div>

{#if edit}
    <MobilePopup
    JoinAs = {state}
        on:click={() => {
            edit = false;
        }}
    />
    
{/if}
<style>
    .main{
        width: fit-content;
        margin: auto;
    }
 .txt, .txt2{
    font-family: 'Orbitron';
font-weight: 700;
line-height: 6.336vw;
letter-spacing: 0.02em;
text-align: center;
}

</style>